import Layout from '@/layout/layout'

const featureRouter = {
  path: '',
  component: Layout,
  redirect: 'noRedirect',
  name: '',
  children: [
    {
      path: 'dashboard',
      component: () => import('@/views/home/home'),
      name: '首页',
      meta: { title: '首页', noCache: true, fixed: true }
    },
    // {
    //   path: 'demo',
    //   component: () => import('@/views/demo'),
    //   name: '组件演示',
    //   meta: { title: '组件演示', noCache: true }
    // }
  ]
}

export default featureRouter
